module.exports = __webpack_public_path__ + "img/bt-1-off.23df0f92.png";